import { orderBy, sumBy } from 'lodash';
import { mapGetters, mapState } from 'vuex';
import { isMarketSettled } from '@/utils/helpers';

export default {
  props: {
    stats: {
      type: Array,
      required: true,
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sortParam: 'totalSharesTraded',
      sortOrder: 'desc',
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapState('market', ['market']),
    isMarketSettled() {
      return isMarketSettled(this.market);
    },
    sortedItems() {
      return orderBy(this.stats, [this.sortParam], [this.sortOrder]);
    },
    isSortable() {
      return this.stats.length > 1;
    },
    secondColumnModifiers() {
      return {
        'market-contracts-stats--middle': this.isSortable && !this.isMarketSettled,
        'market-contracts-stats--last-volume': this.isSortable && this.isMarketSettled,
      };
    },
    thirdColumnModifiers() {
      return {
        'market-contracts-stats--middle': this.isLayoutDesktop,
        'market-contracts-stats--last': !this.isLayoutDesktop,
      };
    },
    totalSharesTradedSum() {
      return sumBy(this.stats, (x) => x.totalSharesTraded).toLocaleString();
    },
    todaysVolumeSum() {
      return sumBy(this.stats, (x) => x.todaysVolume).toLocaleString();
    },
    openInterestSum() {
      return sumBy(this.stats, (x) => x.openInterest).toLocaleString();
    },
  },
  methods: {
    headerSortByModifiers(name) {
      if (!this.isSortable) return {};

      return {
        'market-contracts-stats--sort-by': this.sortParam === name,
        'market-contracts-stats--asc': this.sortParam === name && this.sortOrder === 'asc',
        'market-contracts-stats--desc': this.sortParam === name && this.sortOrder === 'desc',
      };
    },
    sortBy(name) {
      if (this.sortParam === name) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder = 'desc';
        this.sortParam = name;
      }
    },
  },
};
